export default __webpack_public_path__ + "static/media/Portfolio photo 3.24516615.jpg";